// extracted by mini-css-extract-plugin
module.exports = {"InputStyles":"Input_InputStyles__ToHjR"};